import React from 'react';
import moment from 'moment';

const ProjectOverviewHeader = ({ workspacekey, title, firstEvent, lastEvent }) => {
	return (
		<div className="ProjectsOverViewHeaders">
			<div className="projectTitle">
				<span>Projects / </span>
				<span className="projectsName" style={{ textTransform: 'capitalize' }}>
					{workspacekey} /
				</span>
				<span
					className="projectsName"
					style={{ textTransform: 'capitalize', marginLeft: '2px' }}
				>
					{title}
				</span>
			</div>

			<div className="projectEvents">
				<span className="eventdet">First Event</span>
				<span className="dateDetails">
					{firstEvent ? moment(`${firstEvent}`).format('D MMM YYYY') : ''}
				</span>
				<span
					className={
						moment(`${firstEvent}`).local().startOf('seconds').fromNow().includes('in')
							? 'noDays'
							: 'negativeNoDays'
					}
				>
					{moment(`${firstEvent}`).local().startOf('seconds').fromNow().includes('in')
						? '+'
						: '-'}
					{moment(`${firstEvent}`)
						.local()
						.startOf('seconds')
						.fromNow()
						.replace('ago', '')
						.replace('in', '')}
				</span>
			</div>
			<div className="projectEvents">
				<span className="eventdet">Last Event</span>
				<span className="dateDetails">
					{lastEvent ? moment(`${lastEvent}`).format('D MMM YYYY') : ''}
				</span>
				<span
					className={
						moment(`${lastEvent}`).local().startOf('seconds').fromNow().includes('in')
							? 'noDays'
							: 'negativeNoDays'
					}
				>
					{moment(`${lastEvent}`).local().startOf('seconds').fromNow().includes('in')
						? '+'
						: '-'}
					{moment(`${lastEvent}`)
						.local()
						.startOf('seconds')
						.fromNow()
						.replace('ago', '')
						.replace('in', '')}
				</span>
			</div>
		</div>
	);
};

export default ProjectOverviewHeader;
